import request from '@/utils/request'

// 评标报告 标段列表
export const evaluationReportList = (projectCode) => {
    return request.get('/api/agent/evaluationReport/bidSectionList?projectCode='+projectCode)
}
//初始化标段数据
export const evaluationReportInit = (bidSectionCode) => {
    return request.get('/api/agent/evaluationReport/init?bidSectionCode='+bidSectionCode)
}
//根据模版生成评标报告 post
export const createReportByTemplate = (data) => {
    return request.post('/api/agent/evaluationReport/createReportByTemplate?bidSectionCode='+data.bidSectionCode)
}

//保存评标报告
export const evaluationReportAdd = (data) => {
    return request.post('/api/agent/evaluationReport/add',data)
}
// 评标报告 列表
export const evaluationReportDataList = (data) => {
    return request.get('/api/agent/evaluationReport/list?projectCode='+data.projectCode +'&pageNum='+data.pageNum+'&pageSize='+data.pageSize)
}
//评审报告详情
export const evaluationReportDataDetail = (bidEvaluationReportGuid) => {
    return request.get('/api/agent/evaluationReport/detail?bidEvaluationReportGuid='+bidEvaluationReportGuid)
}
//删除 评审报告
export const deleteEvaluationReport = (bidEvaluationReportGuid) => {
    return request.post('/api/agent/evaluationReport/delete?bidEvaluationReportGuid=' + bidEvaluationReportGuid)
}
// 提交（未经过评委会直接提交报告）
export const evaluationReportSubmit = (bidEvaluationReportGuid) => {
    return request.post('/api/agent/evaluationReport/submit?bidEvaluationReportGuid='+bidEvaluationReportGuid)
}

/**
 * 评标结果
 */
//标段列表
export const evaluationResultList = (data) => {
    return request.get('/api/agent/evaluationResult/list?projectCode='+data.projectCode +'&pageNum='+data.pageNum+'&pageSize='+data.pageSize+'&stage='+data.stage)
}
//评委信息
export const evaluationResultExpertInfo = (data) => {
    return request.get('/api/agent/evaluationResult/expertInfo?bidSectionCode='+data.bidSectionCode )
}

//获取文件
export const getEvaluationReportFile = (bidEvaluationReportGuid) => {
    return request.get('/api/agent/evaluationReport/getFile?bidEvaluationReportGuid='+bidEvaluationReportGuid)
}


// 获取群组用于打印聊天
export const getEvaluationGroup = (bidSectionCode) => {
    return request.get('/api/chat/evaluation/group/all?sectionCode='+bidSectionCode)
}

